import { render } from "./video_transcript.vue?vue&type=template&id=c4ad88c4"
import script from "./video_transcript.vue?vue&type=script&lang=js"
export * from "./video_transcript.vue?vue&type=script&lang=js"

import exportComponent from "/home/sophia/sophia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__